import {inject, Injectable} from '@angular/core';
import {CompanyOfficeControllerService, CompanyOfficeDetailResponse} from '@frontend/shared-api';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OfficeListService {
  private readonly companyOfficeController = inject(CompanyOfficeControllerService);

  getAllOfficesWithDetails(): Observable<CompanyOfficeDetailResponse[]> {
    return this.companyOfficeController.getAllOfficesWithDetails();
  }
}
